/* eslint-disable prettier/prettier */
import { useProjectsQuery } from '@/app/services/projectsApi';
import PageTitle from '@/components/common/pageTitle';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Box, Typography, useTheme } from '@mui/material';
import { grey, orange } from '@mui/material/colors';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate, useParams } from 'react-router-dom';

function ProjectsBreadcrumb() {
  const { code, category } = useParams();
  const { t } = useTranslation(['projects', 'common']);
  const navigate = useNavigate();
  const theme = useTheme();

  const { data: project } = useProjectsQuery({
    bringClosed: true,
    projectCode: null,
    searchTerm: code || '',
    projectSubType: '',
    branch: '',
    page: 0,
    size: 10,
  });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box>
        {code ? (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <PageTitle
              title={t('Project.detailed')}
              sx={{ color: orange[600] }}
              onClick={() => navigate('/projects')}
            />
            <ArrowForwardIosIcon
              sx={{
                color: grey[600],
                height: theme.spacing(1.2),
                width: theme.spacing(1.2),
                mx: 1,
              }}
            />
            <Typography sx={{ textAlign: 'center' }} variant="h3">{`${
              project?.content[0]?.code ? project?.content[0]?.code : '???'
            } - ${project?.content[0]?.name ? project?.content[0]?.name : '???'}`}</Typography>
            <ArrowForwardIosIcon
              sx={{
                color: grey[600],
                height: theme.spacing(1.2),
                width: theme.spacing(1.2),
                mx: 1,
              }}
            />
            <Typography sx={{ textAlign: 'center' }} variant="h3">
              {category}
            </Typography>
          </Box>
        ) : (
          <Box sx={{ mb: 0 }}>
            <PageTitle title={t('common:projects')} sx={{ mb: 0 }} />
          </Box>
        )}
      </Box>
      <Box sx={{ width: '100%', height: theme.spacing(0.25), bgcolor: 'grey.300', mb: 2 }} />

      <Outlet />
    </Box>
  );
}
export default ProjectsBreadcrumb;
